import { useEffect } from "react";
import { useState } from "react";
import * as APIModels from "../../models";
import { Modal, Button } from "react-bootstrap";

export type ConfirmationPageProps = {
    show: boolean;
    selectedFiles?: APIModels.FileInfo[];
    attorneyName: string;
    onCancel: () => void;
    onConfirm: () => void;
};

export default function ConfirmationPage({
    show,
    selectedFiles,
    attorneyName,
    onCancel,
    onConfirm,
}: ConfirmationPageProps) {
    useEffect(() => {
        /*
        if (show === true) {
            PortalConfigurationService.getCredentials({
                portalConfigId: portalConfigId ?? "",
            }).then(
                (resp) => {
                    if (resp.successful === true) {
                        setData(resp.data as PortalCredentials);
                    } else {
                        console.log("Error");
                    }
                },
                (error: any) => {
                    console.log(error);
                }
            );
        }
        */
    }, [show]);

    const closeWindow = () => {
        // setData([] as PortalCredentials);
        onCancel();
    };

    const confirm = () => {
        // setData([] as PortalCredentials);
        onConfirm();
    };

    /*
    1                            
    {upload.filenames?.map((v) => (
                                    <li>{v}</li>
                                ))}

                                
    */

    return (
        <div>
            <div className="col-6 mt-3">
                <h4> Summary</h4>

                <p>
                    Please confirm the information below is correct before
                    submitting.
                </p>
            </div>

            <div className="row">
                <div className="col-6">
                    <div className="mb-2">
                        <label htmlFor="upoadFilename" className="form-label">
                            Filenames
                        </label>
                        <ul>
                            <p>
                                {" "}
                                {selectedFiles?.map((v) => (
                                    <li>{v.filename}</li>
                                ))}
                            </p>
                        </ul>
                    </div>
                    <div className="mb-2">
                        <label htmlFor="attorneyName" className="form-label">
                            Attorney Filing on Behalf Of
                        </label>
                        <input
                            type="name"
                            className="form-control"
                            id="attorneyName"
                            value={attorneyName}
                            readOnly
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-12 mb-3">
                    The filing attorney has the responsibility to ensure that
                    any confidential information in the filled documents
                    compiles with all state rules,statues, and codes. By
                    clicking the Submit button below you are acknowledging that
                    you have redacted or prepared the attached document(s) in
                    accordance with all state confidentiality requirements.
                    eReturnsMadeEasy does not check or redact any information.
                </div>
            </div>
            <div className="card-body">
                <div className="row">
                    <div className="col-12 text-end mb-1">
                        <Button
                            type="button"
                            className="btn-danger"
                            onClick={closeWindow}
                        >
                            Cancel
                        </Button>
                        <Button className="btn-primary " onClick={confirm}>
                            Submit
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
